import {
  browserTracingIntegration,
  init,
  setUser as sentrySetUser,
} from '@sentry/react';
import { httpClientIntegration } from '@sentry/integrations';
import { getCurrentRoute } from './utils';
import { getCurrentRouteObject } from '@/router/utils';

export function initialiseSentry(config: Parameters<typeof init>[0]) {
  init({
    beforeSend: (event) => {
      const route = getCurrentRouteObject();
      const team = route.team;
      const teamTagAlreadySet = event.tags?.team;

      if (team && !teamTagAlreadySet) {
        event.tags = {
          ...event.tags,
          team,
        };
      }
      const gqlContext = event.contexts?.gql;
      const { operationName } = gqlContext ?? {};
      if (operationName) {
        event.exception = {
          values: event.exception?.values?.map((exception) => ({
            ...exception,
            value: `${operationName}: ${exception.value ?? ''}`,
          })),
        };
      }
      return event;
    },
    integrations: [
      httpClientIntegration({
        failedRequestStatusCodes: [500, 599],
        failedRequestTargets: [/.*simplywall\.st.*/],
      }),
      browserTracingIntegration({
        beforeStartSpan: (context) => {
          const route = getCurrentRoute();
          return {
            ...context,
            name: route,
          };
        },
      }),
    ],
    ...config,
  });
}

export function setUser(user: Parameters<typeof sentrySetUser>[0]) {
  sentrySetUser(user);
}
